module.exports = __webpack_public_path__ + "static/media/pdp_paperPearlescent.5d94f599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/comparison-module/pdp_paperPearlescent.jpg
// module id = 1533
// module chunks = 70